import { render } from "./index.vue?vue&type=template&id=434f0882&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=434f0882&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434f0882"],['__file',"src/components/DialogMaterial/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "434f0882"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('434f0882', __exports__)) {
    api.reload('434f0882', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=434f0882&scoped=true", () => {
    api.rerender('434f0882', render)
  })

}


export default __exports__